<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </template>
    </com-search>
    <com-card>
      <com-table :columns="columns" ref="table" :api="api">
        <template #type="{ data }">
          <div v-for="(item, index) in data.type.split(',')" :key="index">
            {{ receiveType[item] }}
          </div>
        </template>
        <template #publishTime="{ data }">
          {{ data.publishTime | timeFormate }}
        </template>
        <template #operation="{ data }">
          <el-button type="primary" size="mini" @click="handleDetail(data)">详情</el-button>
          <el-button type="danger" size="mini" @click="handleDel(data)">删除</el-button>
        </template>
      </com-table>
    </com-card>
    <the-edit-notify ref="notifyRef" @onSuccess="init"></the-edit-notify>
  </com-page>
</template>

<script>
import { systemNoticeList, systemNoticeDel } from '@/api/notify'
import theEditNotify from './components/the-edit-notify'

export default {
  components: { theEditNotify },
  data() {
    return {
      searchColumns: [
        {
          label: '名称',
          type: 'input',
          prop: 'title'
        },
        {
          label: '接收方',
          type: 'select',
          prop: 'type',
          option: [
            {
              label: '全部',
              value: 'ALL'
            },
            {
              label: '普通用户',
              value: 'USER'
            },
            {
              label: '商家',
              value: 'BUSINESS'
            },
            {
              label: '合伙人',
              value: 'PARTNER'
            }
          ]
        }
      ],
      columns: [
        {
          label: '名称',
          prop: 'title'
        },
        {
          label: '接收方',
          prop: 'type',
          type: 'slot',
          slotName: 'type'
        },
        {
          label: '发送时间',
          prop: 'publishTime',
          type: 'slot',
          slotName: 'publishTime'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation'
        }
      ],
      receiveType: {
        ALL: '全部',
        USER: '普通用户',
        PARTNER: '合伙人',
        BUSINESS: '商家'
      },
      api: systemNoticeList
    }
  },
  methods: {
    // 初始化
    init() {
      this.$refs.table.init()
    },
    handleAdd() {
      const params = {
        type: 'created'
      }
      this.$refs.notifyRef.open(params)
    },
    // 详情
    handleDetail(e) {
      console.log('e :>> ', e)
      const params = {
        type: 'detail',
        code: e.code
      }
      this.$refs.notifyRef.open(params)
    },
    // 删除
    handleDel(e) {
      this.$confirm('是否确认删除该消息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const res = await systemNoticeDel({ code: e.code })
          if (res.status === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.init()
          }
        })
        .catch(() => {})
    },
    handleSearch(val) {
      this.$refs.table.search(val)
    }
  }
}
</script>

<style lang="scss" scoped></style>
